import { Injectable } from '@angular/core';
import { UserWizardService } from '../../../services/user/user.wizard.service';
import {
  ApiService,
  CountryListService,
  DialogService,
  InputDatastoreService,
  UserService,
  ValuesExchangeProvider
} from '@nrwl/common-lib';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserUpdateService extends UserWizardService {
  constructor(
    apiService: ApiService,
    inputDatastoreService: InputDatastoreService,
    countryListService: CountryListService,
    dialogService: DialogService,
    readonly userService: UserService,
    private exchange: ValuesExchangeProvider
  ) {
    super(
      apiService,
      inputDatastoreService,
      countryListService,
      dialogService,
      userService,
      exchange
    );
  }

  //------------------------------------------------ Wizard control ----------------------------------------------------

  //eslint-disable-next-line
  onFinish(): any {
    if (this.id === 'wizardService.update_fusion_sso_user') {
      this.dataUrl = '/ims/v2/users/' + this.defaultParamsById.id;
    }
    const responseProcessed = this._saveWizardData();
    responseProcessed.subscribe(response => {
      const userName = response.success.username;
      this.currentStep = this.finishingStep;
      if (!this.requestFailed) {
        this.valuesExchange.notifyListeners('user_admin_board', true);
        this.successMessage = 'User has been successfully updated';
        //Extra logic added for atweb which should call another api for email notificaiton
        if (this.userService.isActiveTestProject()) {
          this.notifyUpdate(userName);
        } else {
          this.exchange.notifyListeners('fusion-user-update-info', true);
        }
      }
    });
    return responseProcessed;
  }

  //eslint-disable-next-line
  _handleErrorResponse(response: any): void {
    this.errorMessage = 'User was not updated';

    if (response && response.error && response.error.errors.length !== 0) {
      this.errorDescription = response.error.errors[0];
    }
  }

  notifyUpdate(userName: string): void {
    const tenantId = 'paas.local';
    const userData = {
      emailAddress: this.output['email'],
      firstName: this.output['name'],
      lastName: this.output['surname'],
      isEnabled: true,
      isPrimary: true
    };
    const url = this.currentStep.config.def.notifyUrl + '/' + `${tenantId}` + '/' + `${userName}`;
    this.apiService
      .put$(url, userData)
      .pipe(first())
      .subscribe(response => {
        this.exchange.notifyListeners('fusion-user-update-info', response);
      });
  }
}
